import { useState } from 'react';
import toast from 'react-hot-toast';

export default function Footer() {
  const [email, setEmail] = useState('');

  const cols = [
    { title: 'Discover', links: ['Movies', 'Books', 'Products', 'Trending', 'New Releases', 'Top Rated', 'Collections'] },
    { title: 'Platform', links: ['How It Works', 'AI Model', 'API Docs', 'Developers', 'Open Source', 'Roadmap'] },
    { title: 'Company',  links: ['About Us', 'Careers', 'Press Kit', 'Blog', 'Contact', 'Privacy Policy', 'Terms'] },
  ];

  return (
    <footer style={{ marginTop: '6rem', background: 'var(--bg1)', borderTop: '1px solid var(--border)', position: 'relative', overflow: 'hidden' }}>
      {/* Top accent line */}
      <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 1, background: 'linear-gradient(90deg,transparent,var(--teal),var(--violet),var(--gold),transparent)' }} />

      <div style={{ maxWidth: 1380, margin: '0 auto', padding: '4rem 2rem 2.5rem' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '2.2fr 1fr 1fr 1fr', gap: '3rem', marginBottom: '3rem' }}>

          {/* Brand */}
          <div>
            <div style={{ fontFamily: 'var(--font-display)', fontSize: '1.6rem', fontWeight: 700, marginBottom: '0.85rem' }}>
              Think &amp; <span style={{ color: 'var(--gold)' }}>See</span>
            </div>
            <p style={{ fontSize: '0.85rem', color: 'var(--muted)', lineHeight: 1.8, maxWidth: 280, marginBottom: '1.5rem' }}>
              An AI-powered recommendation platform combining collaborative filtering and content intelligence — surfacing what you'll love before you know you want it.
            </p>
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem', background: 'rgba(0,212,180,.07)', border: '1px solid rgba(0,212,180,.18)', borderRadius: 100, padding: '0.4rem 0.9rem', fontFamily: 'var(--font-mono)', fontSize: '0.65rem', color: 'var(--teal)' }}>
              ⚡ Live AI Model · Updated every 5 min
            </div>

            {/* Newsletter */}
            <div style={{ marginTop: '1.5rem' }}>
              <div style={{ fontFamily: 'var(--font-mono)', fontSize: '0.62rem', letterSpacing: '0.12em', textTransform: 'uppercase', color: 'var(--muted)', marginBottom: '0.75rem' }}>Stay in the loop</div>
              <div style={{ display: 'flex', gap: '0.5rem' }}>
                <input
                  value={email} onChange={e => setEmail(e.target.value)}
                  placeholder="your@email.com"
                  style={{ flex: 1, background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 8, padding: '0.55rem 0.9rem', fontFamily: 'var(--font-body)', fontSize: '0.83rem', color: 'var(--text)', outline: 'none' }}
                />
                <button
                  onClick={() => { if (email) { toast.success('Subscribed! 🎉'); setEmail(''); } else toast.error('Enter an email first'); }}
                  style={{ background: 'linear-gradient(135deg,var(--gold),#c8880a)', color: '#040508', border: 'none', padding: '0.55rem 1.1rem', borderRadius: 8, fontWeight: 800, fontSize: '0.82rem', whiteSpace: 'nowrap', cursor: 'pointer' }}
                >Subscribe</button>
              </div>
            </div>
          </div>

          {/* Link columns */}
          {cols.map(col => (
            <div key={col.title}>
              <div style={{ fontFamily: 'var(--font-mono)', fontSize: '0.62rem', letterSpacing: '0.18em', textTransform: 'uppercase', color: 'var(--muted)', marginBottom: '1.1rem' }}>{col.title}</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.6rem' }}>
                {col.links.map(l => (
                  <div key={l}
                    style={{ fontSize: '0.85rem', color: 'var(--text2)', cursor: 'pointer', transition: 'color 0.2s' }}
                    onMouseEnter={e => e.currentTarget.style.color = 'var(--teal)'}
                    onMouseLeave={e => e.currentTarget.style.color = 'var(--text2)'}
                  >{l}</div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Divider */}
        <div style={{ height: 1, background: 'var(--border)', marginBottom: '2rem' }} />

        {/* Bottom row */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '1rem' }}>
          <div style={{ fontFamily: 'var(--font-mono)', fontSize: '0.68rem', color: 'var(--muted)' }}>
            © {new Date().getFullYear()} <span style={{ color: 'var(--teal)' }}>Think &amp; See</span>. All rights reserved. Built By Himanshu✦
          </div>
          <div style={{ display: 'flex', gap: '1.25rem' }}>
            {['Privacy', 'Terms', 'Cookies', 'Accessibility'].map(l => (
              <span key={l} style={{ fontFamily: 'var(--font-mono)', fontSize: '0.64rem', color: 'var(--muted)', cursor: 'pointer', transition: 'color 0.2s' }}
                onMouseEnter={e => e.currentTarget.style.color = 'var(--teal)'}
                onMouseLeave={e => e.currentTarget.style.color = 'var(--muted)'}
              >{l}</span>
            ))}
          </div>
          <div style={{ display: 'flex', gap: '0.5rem' }}>
            {['𝕏', 'in', 'yt', 'gh', 'ig'].map(s => (
              <button key={s} style={{ width: 34, height: 34, background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 8, color: 'var(--muted)', cursor: 'pointer', fontSize: '0.78rem', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all 0.22s' }}
                onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--teal)'; e.currentTarget.style.color = 'var(--teal)'; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--border)'; e.currentTarget.style.color = 'var(--muted)'; }}
              >{s}</button>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
